import { useEffect, useRef, useState } from "react";

import { fetchReportData } from "../../services/network";
import Phi from "../../Phi/Phi";

import {
  abdomen,
  deficiency,
  Neurology,
  OrthopedicsImg,
} from "../../Assets/images";

import StudentCard from "../../Components/UI/StudentCard";
import ComplaintsCard from "../../Components/UI/ComplaintsCard";
import SectionComplaintsCard from "../../Components/UI/SectionComplaintCard";
import SuggestedInvestigationCard from "../../Components/UI/SuggestedInvestigationCard";
import MultilineTextBox from "../../Components/UI/MultilineTextBox";
import Precaution from "../../Components/UI/Precaution";
import ReportFooter from "../../Components/UI/ReportFooter";

import ScreenShotWrapper from "../../Components/report/ScreenShotWrapper";
import SimpleLoader from "../../Components/Loaders/SimpleLoader";

import {
  AbdomaneIconSvg,
  AccessibilityIconSvg,
  CardiovascularIconSvg,
  DeficienciesIconSvg,
  EditSvg,
  GirlIconSvg,
  HygieneIconSvg,
  LymphaticIconSvg,
  NeurologicalIconSvg,
  OrthopedicsIconSvg,
  RespiratoryIconSvg,
  SearchSuggestionIconSvg,
  SkinIconSvg,
  UserIconSvg,
} from "../../utils/Svgs";

import {
  ReportRXData,
  reportStrings,
} from "../../utils/helpers/newReportHelper";

import { PALLETTE } from "../../utils/theme";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { usePhysicalReportStore } from "../../Store/usePhysicalReport";
import Page from "./Page";
import { useUserStore } from "../../Store/userStore";
import { generateReportLogic } from "../../services/reportService";
import ReportHeader from "../../Components/report/ReportHeader";
import AssessmentNotDoneWrapper from "../../Components/report/AssessmentNotDoneWrapper";

const PhysicalReportScreen = ({ location }: { location: any }) => {
  const [assessmentError, setAssessmentError] = useState(null);
  const physicalReport = usePhysicalReportStore((state) => state);
  const { handleMspLogo, mspLogo } = useUserStore((state) => state);
  const sessionData = sessionStorage.getItem("report_navigation_state");
  const storedParams = sessionData ? JSON.parse(sessionData) : {};

  const [isLoading, setLoading] = useState(false);

  const pdfWrapperRef = useRef<any>(null);

  const params = location?.state || storedParams;

  const studentId = params?.user_id || params?.student_id;
  const eventTrackId = params?.eventTrackId;
  const activityId = params?.activityId;

  const jwt = Phi.getSession()?.jwt;

  const getchData = async (activity_id: number, assessmentId: number) => {
    try {
      setLoading(true);

      const res = await fetchReportData({
        activity_id,
        student_id: studentId,
        jwt,
        event_track_id: assessmentId,
      });

      if (res?.results?.length > 0) {
        const parsedAssessment = JSON.parse(res.results[0].assessmentdata);
        if (parsedAssessment?.data?.Eye_Incomplete_Remark == "105") {
          setAssessmentError(true);
        }

        physicalReport.setPhysicalReportData({
          data: parsedAssessment,
        });
        await generateReportLogic({
          jwt: jwt,
          studentId: studentId,
          handleMspLogo,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // 1. Reset the store to INITIAL_STATE when the component mounts
    // to ensure no leftover data from previous reports
    physicalReport.reset();

    // 2. Fetch new data
    getchData(activityId, eventTrackId);
  }, [activityId, eventTrackId]); // Added dependencies for safety

  return (
    <div
      style={{
        ...V2ReportStyle.mainContainer,
        backgroundColor: PALLETTE.white,
        minHeight: "100vh",
      }}
    >
      {isLoading ? (
        <SimpleLoader />
      ) : (
        <>
          <ReportHeader title="Physical Report" pdfWrapperRef={pdfWrapperRef} />

          <ScreenShotWrapper
            ref={pdfWrapperRef}
            studentName={params?.name || params?.studentname}
            reportType="Physical"
          >
            {(targetRef: any) => (
              <div
                ref={targetRef}
                style={{
                  padding: "3rem",
                  backgroundColor: PALLETTE.background,
                }}
              >
                {assessmentError ? (
                  <AssessmentNotDoneWrapper>
                    <StudentCard
                      name={params?.name || params?.studentname}
                      schoolName={params?.class}
                      icon={
                        params?.gender === "FEMALE" || params?.gender == "F" ? (
                          <GirlIconSvg />
                        ) : (
                          <UserIconSvg />
                        )
                      }
                    />
                  </AssessmentNotDoneWrapper>
                ) : (
                  <Page>
                    <StudentCard
                      name={params?.name || params?.studentname}
                      schoolName={params?.class}
                      icon={
                        params?.gender === "FEMALE" || params?.gender == "F" ? (
                          <GirlIconSvg />
                        ) : (
                          <UserIconSvg />
                        )
                      }
                    />

                    <ComplaintsCard
                      imageSource={undefined}
                      remark=""
                      title="Hygiene"
                      data={physicalReport.Hygiene}
                      topLefticon={<HygieneIconSvg />}
                      label={
                        physicalReport.NeedAttention?.hygiene
                          ? "Need Attention"
                          : "Normal"
                      }
                      suggestionText={
                        physicalReport.NeedAttention?.hygiene
                          ? reportStrings?.physicalHygiene
                          : ""
                      }
                    />

                    <ComplaintsCard
                      imageSource={undefined}
                      remark={
                        physicalReport.PhysicalOthers?.General_signs_Others
                      }
                      title="General Signs"
                      data={physicalReport.GeneralSigns}
                      topLefticon={<AccessibilityIconSvg />}
                      label={
                        physicalReport.NeedAttention?.generalSigns
                          ? "Need Attention"
                          : "Normal"
                      }
                      suggestionText={
                        physicalReport.NeedAttention?.generalSigns
                          ? reportStrings?.physicalGs
                          : ""
                      }
                    />

                    <ComplaintsCard
                      imageSource={undefined}
                      remark={physicalReport.PhysicalOthers?.Head_Others}
                      title="Head"
                      data={physicalReport.Head}
                      topLefticon={<LymphaticIconSvg />}
                      label={
                        physicalReport.NeedAttention?.head
                          ? "Need Attention"
                          : "Normal"
                      }
                      suggestionText={
                        physicalReport.NeedAttention?.head
                          ? reportStrings?.physicalHead
                          : ""
                      }
                    />

                    <SectionComplaintsCard
                      remark={
                        physicalReport.PhysicalOthers?.Lymphatic_PLN_Others
                      }
                      topLefticon={<LymphaticIconSvg />}
                      title="Lymphatic"
                      imageSource={undefined}
                      sections={["Lymphatic_PLN_"]}
                      data={physicalReport.Lymphatic}
                      label={
                        physicalReport.NeedAttention?.lymphatic
                          ? "Need Attention"
                          : "Normal"
                      }
                      suggestionText={
                        physicalReport.NeedAttention?.lymphatic
                          ? reportStrings?.physicalLymphatics
                          : ""
                      }
                    />

                    <ComplaintsCard
                      imageSource={undefined}
                      remark={physicalReport.PhysicalOthers?.Skin_Others}
                      title="Skin"
                      data={physicalReport.Skin}
                      topLefticon={<SkinIconSvg />}
                      label={
                        physicalReport.NeedAttention?.skin
                          ? "Need Attention"
                          : "Normal"
                      }
                      suggestionText={
                        physicalReport.NeedAttention?.skin
                          ? reportStrings?.physicalSkin
                          : ""
                      }
                    />

                    <ComplaintsCard
                      imageSource={undefined}
                      remark={
                        physicalReport.PhysicalOthers?.Cardiovascular_Others
                      }
                      title="Cardiovascular"
                      data={physicalReport.Cardiovascular}
                      topLefticon={<CardiovascularIconSvg />}
                      label={
                        physicalReport.NeedAttention?.cardiovascular
                          ? "Need Attention"
                          : "Normal"
                      }
                      suggestionText={
                        physicalReport.NeedAttention?.cardiovascular
                          ? reportStrings?.physicalCardio
                          : ""
                      }
                    />

                    <ComplaintsCard
                      imageSource={undefined}
                      remark={physicalReport.PhysicalOthers?.Respiratory_Others}
                      title="Respiratory"
                      data={physicalReport.Respiratory}
                      topLefticon={<RespiratoryIconSvg />}
                      label={
                        physicalReport.NeedAttention?.respiratory
                          ? "Need Attention"
                          : "Normal"
                      }
                      suggestionText={
                        physicalReport.NeedAttention?.respiratory
                          ? reportStrings?.physicalRespiratory
                          : ""
                      }
                    />

                    <ComplaintsCard
                      imageSource={abdomen}
                      remark={physicalReport.PhysicalOthers?.Abdomen_Others}
                      title="Abdomen"
                      data={physicalReport.Abdomen}
                      topLefticon={<AbdomaneIconSvg />}
                      label={
                        physicalReport.NeedAttention?.abdomen
                          ? "Need Attention"
                          : "Normal"
                      }
                      suggestionText={
                        physicalReport.NeedAttention?.abdomen
                          ? reportStrings?.physicalAbdomen
                          : ""
                      }
                    />

                    <SectionComplaintsCard
                      remark={
                        physicalReport.PhysicalOthers?.Neurological_Others
                      }
                      topLefticon={<NeurologicalIconSvg />}
                      title="Neurological"
                      imageSource={Neurology}
                      sections={["Neurological_Abnormal_Body_Tone_"]}
                      data={physicalReport.Neurological}
                      label={
                        physicalReport.NeedAttention?.neurological
                          ? "Need Attention"
                          : "Normal"
                      }
                      suggestionText={
                        physicalReport.NeedAttention?.neurological
                          ? reportStrings?.physicalNeuro
                          : ""
                      }
                    />

                    <SectionComplaintsCard
                      remark={physicalReport.PhysicalOthers?.Orthopedics_Others}
                      topLefticon={<OrthopedicsIconSvg />}
                      title="Orthopedics"
                      imageSource={OrthopedicsImg}
                      sections={["Orthopedics_Spinal_Abnormalities_"]}
                      data={physicalReport.Orthopedics}
                      label={
                        physicalReport.NeedAttention?.orthopedics
                          ? "Need Attention"
                          : "Normal"
                      }
                      suggestionText={
                        physicalReport.NeedAttention?.orthopedics
                          ? reportStrings?.physicalOrthopedics
                          : ""
                      }
                    />

                    <SectionComplaintsCard
                      remark={
                        physicalReport.PhysicalOthers
                          ?.Deficiencies_Suspected_Others
                      }
                      topLefticon={<DeficienciesIconSvg />}
                      title="Deficiencies"
                      imageSource={deficiency}
                      sections={["Deficiencies_Suspected_Vitamins_"]}
                      data={physicalReport.Deficiencies_Suspected}
                      label={
                        physicalReport.NeedAttention?.deficiencies_Suspected
                          ? "Need Attention"
                          : "Normal"
                      }
                      suggestionText={
                        physicalReport.NeedAttention?.deficiencies_Suspected
                          ? reportStrings?.physicalDeficiencies
                          : ""
                      }
                    />

                    {physicalReport.PhysicalMetaData
                      ?.Physical_Doctor_Remarks && (
                      <div style={V2ReportStyle.card}>
                        <MultilineTextBox
                          description={
                            physicalReport.PhysicalMetaData
                              ?.Physical_Doctor_Remarks
                          }
                          label="Remarks"
                          icon={<EditSvg />}
                        />
                      </div>
                    )}

                    <SuggestedInvestigationCard
                      label={
                        physicalReport.NeedAttention?.suggestedInvestigation
                          ? "Need Attention"
                          : "Normal"
                      }
                      remark={physicalReport.PhysicalOthers?.Other_Tests}
                      topLefticon={<SearchSuggestionIconSvg />}
                      title="Suggested Investigations"
                      sections={[
                        "Blood_Test_",
                        "Xray_",
                        "Urine_Test_",
                        "Ultrasound_",
                        "Stool_Test_",
                      ]}
                      data={physicalReport.SuggestedInvestigation}
                    />

                    <Precaution data={ReportRXData?.physical} />

                    <ReportFooter
                      doctorName={physicalReport.PhysicalMetaData?.Doctor_No}
                      designation={
                        physicalReport.PhysicalMetaData
                          ?.Physical_Doctor_Designation
                      }
                      docSignature={
                        physicalReport.PhysicalMetaData?.Physical_Doctor_Path
                      }
                      hospitalName={mspLogo[eventTrackId]}
                    />
                  </Page>
                )}
              </div>
            )}
          </ScreenShotWrapper>
        </>
      )}
    </div>
  );
};

export default PhysicalReportScreen;
